// src/reporting/pdf/pdfLayout.js
export const PDF_SECTION_SPACE_BEFORE = 20;
export const PDF_SECTION_SPACE_AFTER = 16;
export const PDF_CONTENT_GAP = 4;

export function addSectionTitle(ctx, title, y, options = {}) {
  const { doc, margins } = ctx;
  const isAtPageTop = y <= margins.top + 2;
  const {
    spaceBefore = isAtPageTop ? 0 : PDF_SECTION_SPACE_BEFORE,
    spaceAfter = PDF_SECTION_SPACE_AFTER,
  } = options;
  const titleY = y + spaceBefore;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(40);
  doc.text(title, margins.left, titleY);

  return titleY + spaceAfter;
}

export function ensurePageSpace(ctx, y, neededHeight, nextPageY = null) {
  const { doc, pageHeight, margins } = ctx;
  const maxY = pageHeight - margins.bottom;

  if (y + neededHeight <= maxY) return y;

  doc.addPage();
  return nextPageY || margins.top;
}

export function addKeyValueBlock(ctx, items, y, options = {}) {
  const { doc, margins, usableWidth } = ctx;
  const {
    columns = 2,
    labelWidth = 95,
    rowHeight = 15,
    columnGap = 24,
    spaceAfter = 8,
  } = options;

  const colWidth = (usableWidth - columnGap * (columns - 1)) / columns;

  doc.setFontSize(8.5);

  items.forEach((item, index) => {
    const col = index % columns;
    const row = Math.floor(index / columns);

    const x = margins.left + col * (colWidth + columnGap);
    const yy = y + row * rowHeight;

    doc.setFont("helvetica", "bold");
    doc.setTextColor(80);
    doc.text(`${item.label}:`, x, yy);

    doc.setFont("helvetica", "normal");
    doc.setTextColor(30);
    doc.text(String(item.value ?? "—"), x + labelWidth, yy, {
      maxWidth: colWidth - labelWidth,
    });
  });

  return y + Math.ceil(items.length / columns) * rowHeight + spaceAfter;
}
